/**
 * Comparison Detail View State Management
 *
 * Manages which view is active when viewing a comparison detail:
 * - outputs: Show the full response outputs
 * - scoring: Show scoring analysis
 * - consensus: Show multi-model consensus analysis (Heatmap, Narrative, Wheel) [FEATURE FLAGGED]
 */

import { useState } from 'react';

export type ComparisonDetailView = 'outputs' | 'scoring' | 'consensus';

export function useComparisonDetailView() {
  const [detailView, setDetailView] = useState<ComparisonDetailView>('outputs');

  return {
    detailView,
    setDetailView,
    isOutputsView: detailView === 'outputs',
    isScoringView: detailView === 'scoring',
    isConsensusView: detailView === 'consensus'
  };
}
